/**
 * INES branch names constants
 */
const INES_BRANCHES = {
  BACHILLERATO: 'Bachillerato',
  TECNICO_UNIVERSITARIO: 'Técnico Universitario',
  ACCOUNT_NAME: 'Educación El Salvador',
};

/**
 * Validates if a branch name is an INES branch
 * @param {string} branchName - The branch name to validate
 * @returns {boolean} True if it's an INES branch, false otherwise
 */
export const isINESBranch = (branchName) => {
  if (!branchName || typeof branchName !== 'string') {
    return false;
  }

  return (
    branchName === INES_BRANCHES.BACHILLERATO ||
    branchName === INES_BRANCHES.TECNICO_UNIVERSITARIO
  );
};

/**
 * Validates and filters INES campaigns from a campaigns array
 * @param {Array} campaigns - Array of campaign objects with name property
 * @returns {Array} Array of INES campaigns only
 */
export const getINESCampaigns = (campaigns) => {
  if (!Array.isArray(campaigns)) {
    return [];
  }

  return campaigns.filter(
    (campaign) => campaign?.name && isINESBranch(campaign.name),
  );
};

/**
 * Validates if there are any INES campaigns in the provided array
 * @param {Array} campaigns - Array of campaign objects with name property
 * @returns {boolean} True if there are INES campaigns, false otherwise
 */
export const hasINESCampaigns = (campaigns) => {
  return getINESCampaigns(campaigns).length > 0;
};

export const isINESAccount = (account) => {
  if (!account || typeof account !== 'object') {
    return false;
  }

  return account.name === INES_BRANCHES.ACCOUNT_NAME;
};

// Export constants for external use
export { INES_BRANCHES };
